// extracted by css-extract-rspack-plugin
export default {"root":"root-_E3XsI text-sm-medium"};